import React from 'react'

const UsuarioNoValido = () => {
  return (
    <div>usuarioNoValido</div>
  )
}

export default UsuarioNoValido;
